import React from "react";
import { DataTable } from "./DataTable";
import { Button, Upload } from "antd";
import { YhBox } from "@/components/YhBox";
import { useIPayableModel } from "../payableModel";

import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { importPropsConfig } from "@/utils/importFile";
import { AuthButton } from "@/components/auth/AuthButton";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { ResourcesAuthBtn } from "@/types/ResourcesAuthEnum";
import { mianCode } from "@/utils/constants";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { formatNum } from "@/utils/utils";
export const DataBox = () => {
    const { loadData, descTotal,rowsDescTotal,selectedRowKeys,copeWithExcel } = useIPayableModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const onEdit = () => {
        copeWithExcel()
    }
    const title = <Button
        className="mr-5"
        type="link"
        shape="round"
        onClick={onEdit}
    >{Locale["export"]}</Button>

    const desc: IDescription[] = [
        {
            // label: "应付金额",
            label: Locale["Payable Amount"],
            value: selectedRowKeys.length === 0 ? descTotal.receivableAmount : formatNum(rowsDescTotal.receivableAmount),
            color: DescriptionColorEnum.red
        },
    ]
    return (
        <YhBox title={title} descriptions={desc}>
            <DataTable />
        </YhBox>
    )
}